import React, { useContext, useState } from 'react';
import { Button, message, Space } from 'antd';

import { SoftwareVulnerabilityReportRecord } from '@totem/components/software/vulnerabilityReport/types';
import VulnerabilityReportContext from '@totem/components/software/vulnerabilityReport/vulnerabilityReportContext';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  record: SoftwareVulnerabilityReportRecord;
};

// Resolves a "needs review" finding. The decision applies to this version of the package for this CVE everywhere
// it is installed: "Add" marks it affected, "Remove" marks it not affected.
const ReviewActions = ({ record }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const { onAction } = useContext(VulnerabilityReportContext);
  const [saving, setSaving] = useState<boolean>(false);

  const decide = (action: 'Add' | 'Remove') => {
    setSaving(true);

    fetch(`${DEVICES_ENDPOINT}/software/cves/affectedVersions`, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getApiToken()}`,
      }),
      body: JSON.stringify({
        action,
        cve: record.vulnerability,
        version: record.packageVersion,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          message.error('The review decision was not saved.');
          return;
        }
        message.success(
          action === 'Add'
            ? `${record.packageName} ${record.packageVersion} marked affected by ${record.vulnerability}`
            : `${record.packageName} ${record.packageVersion} marked not affected by ${record.vulnerability}`,
        );

        onAction('refresh');
      })
      .catch(() => message.error('The review decision was not saved.'))
      .finally(() => setSaving(false));
  };

  return (
    <Space size="small">
      <Button
        size="small"
        danger
        loading={saving}
        onClick={() => decide('Add')}
      >
        Affected
      </Button>
      <Button size="small" loading={saving} onClick={() => decide('Remove')}>
        Not affected
      </Button>
    </Space>
  );
};

export default ReviewActions;
